export default "__VITE_ASSET__BRAft17n__"